/**
 * @param {string} selector
 */
export const $ = (selector) => document.querySelector(selector);
